import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { LOCALES } from 'project-constants';
import { CONFIG } from 'config';

import { messages as enMessages } from './locales/en/messages';
import { messages as ruMessages } from './locales/ru/messages';
import { positions, transitions, Provider as AlertProvider, AlertTemplate } from './libs/react-alert';
import App from './modules/App';
import reportWebVitals from './reportWebVitals';
import './index.scss';

const ALERT_OPTIONS = {
	timeout: 5000,
	width: '500px',
	position: positions.TOP_RIGHT,
	transition: transitions.SCALE,
};

i18n.load(LOCALES.en, enMessages);
i18n.load(LOCALES.ru, ruMessages);
i18n.activate(CONFIG.locale);

document.body.classList.add(CONFIG.brand);
const root = createRoot(document.getElementById('root')!);

root.render(
	<StrictMode>
		<I18nProvider i18n={i18n}>
			{/*@ts-expect-error Rewrite react-alert package to TS*/}
			<AlertProvider template={AlertTemplate} {...ALERT_OPTIONS}>
				<App />
			</AlertProvider>
		</I18nProvider>
	</StrictMode>,
);

reportWebVitals();
